import { render } from "./CommentVoteButtons.vue?vue&type=template&id=1331a7ea"
import script from "./CommentVoteButtons.vue?vue&type=script&lang=js"
export * from "./CommentVoteButtons.vue?vue&type=script&lang=js"

import "./CommentVoteButtons.vue?vue&type=style&index=0&id=1331a7ea&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__